import { useState, useCallback } from 'react';

import { CartItem, StockAdjustmentResult } from '../types/CartTypes';

export function useStockAdjustment() {
  const [isAdjusting, setIsAdjusting] = useState(false);

  const adjustCartForStock = useCallback(
    (cartList: CartItem[]): StockAdjustmentResult => {
      setIsAdjusting(true);

      try {
        const itemsToUpdate: { cartUuid: string; quantity: number }[] = [];
        const itemsToDelete: string[] = [];
        let hasAdjustments = false;

        const adjustedWithDeletionMarks = cartList.map((item) => {
          const maxQuantity =
            item.productOption.stock - item.productOption.holdStock;
          const minQuantity = item.productOption.minimumOrderQuantity || 1;

          // 재고 0 이하면 삭제 대상
          if (maxQuantity <= 0) {
            hasAdjustments = true;
            itemsToDelete.push(item.uuid);
            return item;
          }

          // 재고 초과가 아니면 그대로 유지
          if (item.quantity <= maxQuantity) {
            return item;
          }

          hasAdjustments = true;

          // 재고는 있지만 MOQ보다 적게 남은 경우 삭제 대상
          if (maxQuantity < minQuantity) {
            itemsToDelete.push(item.uuid);
            return item;
          }

          // 수량 조정
          itemsToUpdate.push({
            cartUuid: item.uuid,
            quantity: maxQuantity,
          });

          return { ...item, quantity: maxQuantity };
        });

        const adjustedCartList = adjustedWithDeletionMarks.filter(
          (item) => !itemsToDelete.includes(item.uuid),
        );

        return {
          adjustedCartList,
          hasAdjustments,
          itemsToUpdate,
          itemsToDelete,
        };
      } finally {
        setIsAdjusting(false);
      }
    },
    [],
  );

  return {
    adjustCartForStock,
    isAdjusting,
  };
}
